module.exports = __webpack_public_path__ + "img/mini_alert.82793179.svg";